import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  getEtiquetasByPadreId,
  deleteEtiqueta,
  updateEtiquetasSortItems,
  getEtiquetas,
  getEtiquetaById,
  insertEtiqueta,
  updateEtiqueta,
} from 'services/catalogo'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_ETIQUETAS_BY_PADREID(action) {
  try {
    const etiquetasData = yield call(getEtiquetasByPadreId, action.payload)
    if (etiquetasData.ok) {
      yield put({
        type: actions.ETIQUETAS_LOAD_SUCCEEDED,
        payload: etiquetasData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar etiquetas')
      put({
        type: actions.ETIQUETAS_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.ETIQUETAS_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_ETIQUETA_BY_ID(action) {
  try {
    const etiquetaData = yield call(getEtiquetaById, action.payload)
    if (etiquetaData.ok) {
      yield put({
        type: actions.ETIQUETA_BYID_LOAD_SUCCEEDED,
        payload: etiquetaData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar etiqueta')
      put({
        type: actions.ETIQUETA_BYID_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.ETIQUETA_BYID_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_ALL_ETIQUETAS() {
  try {
    const etiquetasData = yield call(getEtiquetas)
    if (etiquetasData.ok) {
      yield put({
        type: actions.ETIQUETAS_LOAD_SUCCEEDED,
        payload: etiquetasData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar etiquetas')
      put({
        type: actions.ETIQUETAS_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.ETIQUETAS_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_ETIQUETAS_SORT_ITEMS(action) {
  try {
    const etiquetasObj = yield call(updateEtiquetasSortItems, action.payload)
    if (etiquetasObj.ok) {
      putMessage(messageType.SUCCESS, 'Orden de Etiquetas modificado correctamente')
      yield put({
        type: actions.ETIQUETA_SORT_ITEMS_UPDATE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar el Orden de Etiquetas')
      yield put({
        type: actions.ETIQUETA_SORT_ITEMS_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar el Orden de Etiquetas')
    yield all([
      put({
        type: actions.ETIQUETA_SORT_ITEMS_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_ETIQUETA(action) {
  try {
    const etiquetaResult = yield call(deleteEtiqueta, action.payload)
    if (etiquetaResult.ok) {
      putMessage(messageType.SUCCESS, 'Etiqueta eliminada correctamente')
      yield put({
        type: actions.ETIQUETA_DELETE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar Etiqueta')
      yield put({
        type: actions.ETIQUETA_DELETE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar Etiqueta')
    yield all([
      put({
        type: actions.ETIQUETA_DELETE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_ETIQUETA(action) {
  try {
    const etiquetaObj = yield call(updateEtiqueta, action.payload)
    if (etiquetaObj.ok) {
      putMessage(messageType.SUCCESS, 'Etiqueta modificada correctamente')
      yield put({
        type: actions.ETIQUETA_UPDATE_SUCCEEDED,
        payload: etiquetaObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar etiqueta')
      yield put({
        type: actions.ETIQUETA_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar etiqueta')
    yield all([
      put({
        type: actions.ETIQUETA_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_ETIQUETA(action) {
  try {
    const etiquetaObj = yield call(insertEtiqueta, action.payload)
    if (etiquetaObj.ok) {
      putMessage(messageType.SUCCESS, 'Etiqueta creada correctamente')
      yield put({
        type: actions.ETIQUETA_INSERT_SUCCEEDED,
        payload: etiquetaObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear etiqueta')
      yield put({
        type: actions.ETIQUETA_INSERT_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear etiqueta')
    yield all([
      put({
        type: actions.ETIQUETA_INSERT_FILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.ETIQUETAS_LOAD_REQUESTED, GET_ETIQUETAS_BY_PADREID),
    takeEvery(actions.ETIQUETA_DELETE_REQUESTED, DELETE_ETIQUETA),
    takeEvery(actions.ETIQUETA_SORT_ITEMS_UPDATE_REQUESTED, UPDATE_ETIQUETAS_SORT_ITEMS),
    takeEvery(actions.ETIQUETAS_LOAD_ALL_REQUESTED, GET_ALL_ETIQUETAS),
    takeEvery(actions.ETIQUETA_BYID_LOAD_REQUESTED, GET_ETIQUETA_BY_ID),
    takeEvery(actions.ETIQUETA_UPDATE_REQUESTED, UPDATE_ETIQUETA),
    takeEvery(actions.ETIQUETA_INSERT_REQUESTED, INSERT_ETIQUETA),
  ])
}
